var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMovementArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 13.75L29.4875 15.5125L32.7125 18.75H21.25V7.2875L24.4875 10.5125L26.25 8.75L20 2.5L13.75 8.75L15.5125 10.5125L18.75 7.2875V18.75H7.2875L10.5125 15.5125L8.75 13.75L2.5 20L8.75 26.25L10.5125 24.4875L7.2875 21.25H18.75V32.7125L15.5125 29.4875L13.75 31.25L20 37.5L26.25 31.25L24.4875 29.4875L21.25 32.7125V21.25H32.7125L29.4875 24.4875L31.25 26.25L37.5 20L31.25 13.75Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovementArrow);
export default __webpack_public_path__ + "static/media/movement-arrow.282cb37fbbb864fd489ea3c018ae45f7.svg";
export { ForwardRef as ReactComponent };